import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import type { RootState } from '@/store'

// Base query with auth header
const baseQuery = fetchBaseQuery({
  baseUrl: '/api',
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as RootState).auth.accessToken
    if (token) {
      headers.set('Authorization', `Bearer ${token}`)
    }
    return headers
  },
})

// API response type
export interface ApiResponse<T> {
  success: boolean
  message?: string
  data: T
  totalCount?: number
}

// Create API with empty endpoints (will be extended by other services)
export const api = createApi({
  reducerPath: 'api',
  baseQuery,
  tagTypes: [
    'Auth',
    'Board',
    'Content',
    'Program',
    'Facility',
    'Reservation',
    'Member',
    'Survey',
    'Main',
    'Search',
    'PopularKeywords',
    'CareSvc',
    'InstrRecr',
    'MentorRecr',
    'Menu',
    'Chatbot',
    'ChatHistory',
    'ChatbotQna',
  ],
  endpoints: () => ({}),
})
